/* ============================================================
   KICK SPEED - size gate (assets/ks-size-gate.js)
   Loaded from layout/theme.liquid, before theme.js.

   The theme ticks the first size of every product form on arrival, so
   one tap on Add to cart bought the smallest size. This script:
     - leaves the size empty until the shopper picks one
       (the colour stays as the theme set it),
     - shows "Choose your size" on the Add to cart button and hides the
       express buttons (PayPal) until a size is picked,
     - on a tap on the button without a size: scrolls to the sizes,
       shows a short hint and pulses the size buttons.
   Works for the product page, the featured product on the home page and
   the quick view (forms added later are picked up by an observer).

   Not touched (the size really was chosen):
     - a product URL with ?variant= (Google Shopping, shared links),
       except links from collection cards, which only carry the colour
       and add &ks_c=1,
     - any size picked by a script with a change event: the saved-size
       helper (ks-size-helper), the dock, ?ks_foot= links.
   Sold-out products and forms with one size only are left alone.
   ============================================================ */
(function () {
  'use strict';
  if (window.__ksSizeGate) return;
  window.__ksSizeGate = true;

  var CHOOSE = 'Choose your size';
  var HINT = 'Please choose your size first';
  var SIZE_RE = /size/i;
  var FORM_SEL = 'form.product-single__form';

  var q;
  try { q = new URLSearchParams(location.search); } catch (e) { q = null; }
  var hasVariant = !!(q && q.has('variant'));
  var colourOnly = !!(q && q.get('ks_c') === '1');

  var gates = [];
  var seq = 0;

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function formOf(input) {
    if (!input) return null;
    if (input.form) return input.form;
    var id = input.getAttribute && input.getAttribute('form');
    return id ? document.getElementById(id) : (input.closest ? input.closest('form') : null);
  }
  function gateFor(form) {
    if (!form) return null;
    for (var i = 0; i < gates.length; i++) if (gates[i].form === form) return gates[i];
    return null;
  }
  function sizeRadios(form) {
    var out = [];
    if (!form || !form.id) return out;
    var all = document.querySelectorAll('input[type="radio"][data-variant-input]');
    for (var i = 0; i < all.length; i++) {
      var r = all[i];
      if (formOf(r) === form && SIZE_RE.test(r.name || '')) out.push(r);
    }
    return out;
  }
  function isMainProduct(form) {
    var sec = form.closest('[data-section-type="product"]');
    if (!sec || sec.getAttribute('data-history') !== 'true') return false;
    var h = sec.getAttribute('data-product-handle');
    return !!h && location.pathname.indexOf('/products/' + h) > -1;
  }
  function textEl(g) {
    return g.btn.querySelector('[data-add-to-cart-text]') || g.btn;
  }

  function paintButton(g) {
    if (!g.pending) return;
    var t = textEl(g);
    if (t.textContent.trim() !== CHOOSE) t.textContent = CHOOSE;
    /* the theme may have disabled it for the size it ticked; the shopper
       still needs a button that leads to the sizes */
    g.btn.disabled = false;
    g.btn.removeAttribute('disabled');
    g.btn.classList.remove('disabled');
    g.btn.setAttribute('aria-describedby', g.hint.id);
  }
  function clearSizes(g) {
    for (var i = 0; i < g.radios.length; i++) {
      if (g.radios[i].checked) g.radios[i].checked = false;
    }
  }
  /* the theme writes ?variant= into the address when the colour changes;
     mark it as colour-only so a reload does not pick a size */
  function markUrl(g) {
    if (!g.main || !window.history || !history.replaceState) return;
    try {
      var u = new URL(location.href);
      if (u.searchParams.has('variant') && u.searchParams.get('ks_c') !== '1') {
        u.searchParams.set('ks_c', '1');
        history.replaceState(history.state, '', u.toString());
      }
    } catch (e) {}
  }

  function hold(g) {
    g.pending = true;
    g.form.classList.add('ks-size-pending');
    clearSizes(g);
    paintButton(g);
  }
  function release(g) {
    g.pending = false;
    g.form.classList.remove('ks-size-pending');
    if (g.wrap) g.wrap.classList.remove('ks-size-asked');
    g.hint.removeAttribute('role');
    g.btn.removeAttribute('aria-describedby');
    /* the theme sets the real text (Add to cart / Sold out) right after,
       on its own variant change; this covers the case it does not */
    var t = textEl(g);
    if (t.textContent.trim() === CHOOSE) t.textContent = t.getAttribute('data-default-text') || 'Add to cart';
  }
  function ask(g) {
    if (!g) return;
    var target = g.fieldset || g.wrap;
    if (g.wrap) g.wrap.classList.add('ks-size-asked');
    g.hint.setAttribute('role', 'alert');
    if (target) {
      try {
        target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
      } catch (e) { target.scrollIntoView(); }
      target.classList.remove('ks-size-pulse');
      void target.offsetWidth;
      target.classList.add('ks-size-pulse');
      clearTimeout(g.pulseT);
      g.pulseT = setTimeout(function () { target.classList.remove('ks-size-pulse'); }, 2600);
    }
  }

  function setup(form) {
    if (!form || gateFor(form) || form.getAttribute('data-ks-gate') === 'off') return;
    var btn = form.querySelector('[data-add-to-cart]');
    if (!btn) return;
    var radios = sizeRadios(form);
    if (radios.length < 2) return;
    var main = isMainProduct(form);
    /* a size that came with the link was chosen on purpose */
    if (main && hasVariant && !colourOnly) { form.setAttribute('data-ks-gate', 'off'); return; }
    /* sold out everywhere: the theme already shows Sold out */
    if (btn.disabled && !radios.some(function (r) { return !r.classList.contains('disabled'); })) {
      form.setAttribute('data-ks-gate', 'off');
      return;
    }
    var fieldset = radios[0].closest('fieldset');
    var wrap = radios[0].closest('.variant-wrapper') || fieldset;
    var hint = document.createElement('p');
    hint.className = 'ks-size-hint';
    hint.id = 'KsSizeHint-' + (++seq);
    hint.textContent = HINT;
    if (fieldset && fieldset.parentNode) fieldset.parentNode.insertBefore(hint, fieldset);
    else form.insertBefore(hint, form.firstChild);
    var g = { form: form, btn: btn, radios: radios, fieldset: fieldset, wrap: wrap, hint: hint, main: main, pending: false, pulseT: 0 };
    gates.push(g);
    form.setAttribute('data-ks-gate', 'on');
    hold(g);
  }
  function scan() {
    var forms = document.querySelectorAll(FORM_SEL);
    for (var i = 0; i < forms.length; i++) setup(forms[i]);
    /* forms that left the page (quick view closed and rebuilt) */
    gates = gates.filter(function (g) { return document.documentElement.contains(g.form); });
  }

  /* a size picked by hand or by one of our scripts (they send change) */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio' || !SIZE_RE.test(t.name || '')) return;
    var g = gateFor(formOf(t));
    if (g && g.pending && t.checked) release(g);
  }, true);

  /* after a colour change the theme ticks a size again: take it back */
  document.addEventListener('variant:change', function () {
    setTimeout(function () {
      for (var i = 0; i < gates.length; i++) {
        var g = gates[i];
        if (!g.pending) continue;
        clearSizes(g);
        paintButton(g);
        markUrl(g);
      }
    }, 0);
  });

  /* Add to cart without a size: show the sizes instead */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-add-to-cart]') : null;
    if (!b) return;
    var g = gateFor(b.form || b.closest('form'));
    if (!g || !g.pending) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ask(g);
  }, true);
  document.addEventListener('submit', function (e) {
    var g = gateFor(e.target);
    if (!g || !g.pending) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ask(g);
  }, true);

  window.KSSizeGate = {
    pending: function (form) { var g = gateFor(form); return !!(g && g.pending); },
    ask: function (form) { var g = gateFor(form); if (g && g.pending) { ask(g); return true; } return false; },
    scan: scan
  };

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  /* the quick view and other forms that arrive later: only a new product
     form starts a scan, so the many small changes other scripts make to
     the page (texts, images, the dock) cost nothing */
  if (window.MutationObserver) {
    var mt = 0;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches(FORM_SEL)) || (n.querySelector && n.querySelector(FORM_SEL))) {
            clearTimeout(mt);
            mt = setTimeout(scan, 60);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
